import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getRegularClass = ({ id }) => {
  return api.get(`admin/classes/${id}`);
};

export const getRegularClassQueryOptions = params => {
  return queryOptions({
    queryKey: ["regular-classes", params],
    queryFn: () => getRegularClass(params),
  });
};

export const useRegularClassQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getRegularClassQueryOptions(params),
    ...queryConfig,
  });
};
